export default __webpack_public_path__ + "static/media/profilaxis_tromboembolismo_venoso.d6a020c3.pdf";